/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Label_ActionInputs */

const en_story_bank_label_action = /** @type {(inputs: Story_Bank_Label_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const de_story_bank_label_action = /** @type {(inputs: Story_Bank_Label_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const fr_story_bank_label_action = /** @type {(inputs: Story_Bank_Label_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const es_story_bank_label_action = /** @type {(inputs: Story_Bank_Label_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const it_story_bank_label_action = /** @type {(inputs: Story_Bank_Label_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const nl_story_bank_label_action = /** @type {(inputs: Story_Bank_Label_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const pl_story_bank_label_action = /** @type {(inputs: Story_Bank_Label_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const fi_story_bank_label_action = /** @type {(inputs: Story_Bank_Label_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const da_story_bank_label_action = /** @type {(inputs: Story_Bank_Label_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const sv_story_bank_label_action = /** @type {(inputs: Story_Bank_Label_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Story_Bank_Label_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_label_action = /** @type {((inputs?: Story_Bank_Label_ActionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Label_ActionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_label_action(inputs)
	if (locale === "fr") return fr_story_bank_label_action(inputs)
	if (locale === "es") return es_story_bank_label_action(inputs)
	if (locale === "it") return it_story_bank_label_action(inputs)
	if (locale === "nl") return nl_story_bank_label_action(inputs)
	if (locale === "pl") return pl_story_bank_label_action(inputs)
	if (locale === "fi") return fi_story_bank_label_action(inputs)
	if (locale === "da") return da_story_bank_label_action(inputs)
	if (locale === "sv") return sv_story_bank_label_action(inputs)
	return en_story_bank_label_action(inputs)
});